import React, { FC } from 'react';
import { makeStyles, StylesProvider, MuiThemeProvider } from '@material-ui/core/styles';
import theme from './index';

const useGlobalStyles = makeStyles({
  '@global': {
    body: {
      'overscroll-behavior': 'none',
    },
  },
});

const ThemeProvider: FC = ({ children }) => {
  useGlobalStyles();

  return (
    <StylesProvider>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </StylesProvider>
  );
};

export default ThemeProvider;
